import axios from 'axios';

import { isStagingEnv } from './environment';

const CONVELIO_BASEURL = `https://api${
  isStagingEnv ? '.staging' : ''
}.convelio.com`;

const CONVELIO_ENDPOINTS = {
  getGPlaces: `${CONVELIO_BASEURL}/io/gplace?input=`,
  getGplaceDetails: `${CONVELIO_BASEURL}/io/gplace-details?p=`,
  postShippingRequest: `${CONVELIO_BASEURL}/quoting/v1/shipping-request`,
  getShippingMethods: `${CONVELIO_BASEURL}/offering/v1/shipping-methods/`,
  getApiPrice: `${CONVELIO_BASEURL}/io`
};

export const Api = {
  getGplaces: async (input) => {
    return await axios
      .request({
        url: `${CONVELIO_ENDPOINTS.getGPlaces}${input}`,
        method: 'GET'
      })
      .then((res) => {
        if (res.data.err !== 0) {
          throw res.data.msg;
        }
        return res.data;
      })
      .catch((err) => console.log(err));
  },
  getGplaceDetails: async (place_id) => {
    return await axios
      .request({
        url: `${CONVELIO_ENDPOINTS.getGplaceDetails}${place_id}`,
        method: 'GET'
      })
      .then((res) => {
        if (res.data.err !== 0) {
          throw res.data.msg;
        }
        return res.data;
      })
      .catch((err) => console.log(err));
  },
  postShippingRequest: (from, to) => {
    const payload = {
      parentId: null,
      channel: 1,
      contactId: isStagingEnv
        ? 'bae8bfbf-fb6b-11eb-997e-42010a1ed00e'
        : '84289a03-fb72-11eb-b929-42010a5f520a',
      deliveryLocation: {
        streetAddress: to.street,
        state: to.state,
        city: to.city,
        postcode: to.postal_code,
        countryCode: to.countryCode,
        latitude: to.lat,
        longitude: to.lng
      },
      pickups: [
        {
          pickupLocation: {
            streetAddress: from.street,
            state: from.state,
            city: from.city,
            postcode: from.postal_code,
            countryCode: from.countryCode,
            latitude: from.lat,
            longitude: from.lng
          },
          items: [
            {
              type: 'fine_art.sculpture',
              description: 'description',
              quantity: 1,
              packingCondition: 'NOT_PACKED',
              commercialValue: {
                amount: 1000,
                currencyCode: 'EUR'
              },
              parts: [
                {
                  description: '',
                  quantity: 1,
                  dimensions: {
                    length: 10,
                    depth: 10,
                    height: 10,
                    unit: 'cm'
                  },
                  weight: {
                    unit: 'kg',
                    value: 1
                  }
                }
              ]
            }
          ]
        }
      ]
    };
    return axios.request({
      url: `${CONVELIO_ENDPOINTS.postShippingRequest}`,
      data: payload,
      method: 'POST'
    });
  },
  getShippingMethods: (shipping_request_id) => {
    return axios.request({
      url: `${CONVELIO_ENDPOINTS.getShippingMethods}${shipping_request_id}`,
      method: 'GET'
    });
  },
  getApiPrice: async (
    from,
    to,
    item,
    freightMethod = 'road_freight_courier'
  ) => {
    const body = new FormData();
    const payload = {
      allPickups: [
        {
          from: {
            street_number: '',
            street: from.street,
            street2: '',
            state: from.state,
            city: from.city,
            district: '',
            postal_code: from.postal_code,
            countryCode: from.countryCode,
            country: from.country,
            lat: from.lat,
            lng: from.lng,
            utcOffset: '',
            vicinity: '',
            adr_address: from.street,
            addrText: from.street
          },
          metric: 1,
          items: [
            {
              quantity: 1,
              packingType: 'notpacked',
              commercialValue: item?.commmercialValue || 1000,
              valueCurrency: 978,
              type: item?.type || 'lamp.chandelier',
              parts: [
                {
                  length: item?.length || 10,
                  width: item?.width || 10,
                  height: item?.height || 10,
                  weight: item?.weight || 1,
                  quantity: item?.quantity || 1
                }
              ]
            }
          ],
          stackId: 1
        }
      ],
      to: {
        street_number: '',
        street: to.street,
        street2: '',
        state: to.state,
        city: to.city,
        district: '',
        postal_code: to.postal_code,
        countryCode: to.countryCode,
        country: to.country,
        lat: to.lat,
        lng: to.lng,
        utcOffset: '',
        vicinity: '',
        adr_address: to.street,
        addrText: to.street
      },
      freightSpeed: 'Regular Speed',
      freightMethod,
      deliveryMethod: 'curbside',
      deliveryType: {
        type: 'house',
        floor: '0',
        fitInStaircase: true
      },
      hasPersonalInsurance: false,
      forexCurrencyCode: '978',
      services: {
        documents: []
      }
    };
    body.append('requestData', JSON.stringify(payload));
    return await axios
      .request({
        url: `${CONVELIO_ENDPOINTS.getApiPrice}`,
        data: body,
        method: 'POST'
      })
      .then((res) => {
        if (res.data.err !== 0) {
          throw res.data.msg;
        }
        return res.data;
      });
  }
};
